import { render } from "./Lettre.vue?vue&type=template&id=653556a0"
import script from "./Lettre.vue?vue&type=script&lang=js"
export * from "./Lettre.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__